import { Heading, Paragraph, Tag } from '@audio-network/componentlibrary'
import Image from 'next/image'
import { useTranslation } from 'next-i18next'

import Link from '@/components/shared/Link/Link'
import { ALBUM_ARTWORK_S } from '@/constants/sizing'
import optimizeContentfulImage from '@/utils/contentful/optimizeContentfulImage'
import { shouldDisplayMixVariation } from '@/utils/music/shouldDisplayMixVariation'

import { useTrackActions } from '../../TrackActions.hooks'
import styles from './TrackTrayHeader.module.css'
import { TrackTrayHeaderProps } from './TrackTrayHeader.types'

const TrackTrayHeader = ({
	track,
	source = 'Track Tray',
}: TrackTrayHeaderProps): JSX.Element => {
	const { t } = useTranslation(['trackrow'])
	const { trackOptions } = useTrackActions({ track, source })

	const mixes = trackOptions.find((option) => option.id === 'Mixes')
	const stems = trackOptions.find((option) => option.id === 'Stems')

	const showTags = mixes || stems
	const displayMixVariation = shouldDisplayMixVariation(track)

	const imageUrl = optimizeContentfulImage(track.album?.artworkImageUrl, {
		width: ALBUM_ARTWORK_S,
		height: ALBUM_ARTWORK_S,
	})

	return (
		<header className={styles.header}>
			{track.album?.artworkImageUrl && (
				<div className={styles.background}>
					<Image
						src={imageUrl}
						alt=""
						width={ALBUM_ARTWORK_S}
						height={ALBUM_ARTWORK_S}
						className={styles.blur}
					/>
				</div>
			)}
			<Link href={`/track/${track.id}`}>
				<Heading level={2} size="S" className={styles.title}>
					{track.title}
				</Heading>
			</Link>

			{displayMixVariation && (
				<span className={styles.mixVariation}>{track.mixVariation}</span>
			)}
			<Paragraph className={styles.description} size="S">
				{track.description}
			</Paragraph>
			{showTags && (
				<div className={styles.tags}>
					{mixes && (
						<Tag
							className={styles.tag}
							href={mixes.href}
							onClick={mixes.onClick}
						>
							{t('mixes', { mixCount: track.mixCount })}
						</Tag>
					)}
					{stems && (
						<Tag
							className={styles.tag}
							href={stems.href}
							onClick={stems.onClick}
						>
							{t('stems')}
						</Tag>
					)}
				</div>
			)}
			{track.album?.artworkImageUrl && (
				<Image
					src={imageUrl}
					alt=""
					width={ALBUM_ARTWORK_S}
					height={ALBUM_ARTWORK_S}
					className={styles.artwork}
				/>
			)}
		</header>
	)
}

export default TrackTrayHeader
